<script>
import PROJECTS_INFO from '@/data/projects_info.js';

export default {
	props: ['project', 'index'],
	emits: ['select'],
	computed: {
		tag() {
			return PROJECTS_INFO[this.project.code]?.singleProjectHeader?.singleProjectTag ?? '';
		},
		year() {
			return PROJECTS_INFO[this.project.code]?.singleProjectHeader?.singleProjectDate ?? '';
		},
	},
	methods: {
		handleClick(e) {
			const rect = e.currentTarget.getBoundingClientRect();
			this.$emit('select', { project: this.project, rect });
		},
	},
};
</script>

<template>
	<div @click="handleClick" class="project-row">
		<span class="project-num">{{ String(index + 1).padStart(2, '0') }}</span>

		<div class="project-info">
			<span class="project-title">{{ project.title }}</span>
			<span class="project-tag">{{ tag }}</span>
		</div>

		<span class="project-year">{{ year }}</span>
		<span class="project-arrow">↗</span>

		<img :src="project.img" class="project-thumb" aria-hidden="true" />
	</div>
</template>

<style scoped>
.project-row {
	position: relative;
	display: flex;
	align-items: center;
	gap: 28px;
	padding: 28px 0;
	border-bottom: 1px solid rgba(255, 255, 255, 0.07);
	cursor: pointer;
	overflow: hidden;
	transition: background 0.2s;
}
.project-row:first-child {
	border-top: 1px solid rgba(255, 255, 255, 0.07);
}
.project-row:hover {
	background: rgba(255, 255, 255, 0.03);
}
.project-num {
	font-family: 'Helvetica Neue', Arial, sans-serif;
	font-size: 0.7rem;
	color: rgba(255, 255, 255, 0.2);
	letter-spacing: 0.1em;
	flex: 0 0 28px;
}
.project-info {
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 5px;
	min-width: 0;
}
.project-title {
	font-family: 'Library-3AM', 'Helvetica Neue', Arial, sans-serif;
	font-size: clamp(1.1rem, 2.4vw, 1.8rem);
	color: rgba(255, 255, 255, 0.82);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	transition: color 0.2s;
}
.project-row:hover .project-title {
	color: #fff;
}
.project-tag {
	font-family: 'Helvetica Neue', Arial, sans-serif;
	font-size: 0.72rem;
	color: rgba(255, 255, 255, 0.28);
	letter-spacing: 0.12em;
	text-transform: uppercase;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.project-year {
	font-family: 'Helvetica Neue', Arial, sans-serif;
	font-size: 0.72rem;
	color: rgba(255, 255, 255, 0.2);
	letter-spacing: 0.08em;
	flex: 0 0 auto;
}
.project-arrow {
	font-size: 1.1rem;
	color: rgba(255, 255, 255, 0.2);
	flex: 0 0 auto;
	transition: color 0.2s, transform 0.2s;
}
.project-row:hover .project-arrow {
	color: rgba(255, 255, 255, 0.7);
	transform: translate(2px, -2px);
}
.project-thumb {
	position: absolute;
	right: 48px;
	top: 50%;
	transform: translateY(-50%) scale(0.94);
	width: 140px;
	height: 90px;
	object-fit: cover;
	border-radius: 6px;
	opacity: 0;
	pointer-events: none;
	transition: opacity 0.3s ease, transform 0.3s ease;
}
.project-row:hover .project-thumb {
	opacity: 1;
	transform: translateY(-50%) scale(1);
}

@media (max-width: 600px) {
	.project-row {
		flex-wrap: wrap;
		gap: 8px 14px;
		padding: 20px 0;
		align-items: center;
	}
	.project-year { display: none; }
	.project-arrow { display: none; }
	.project-thumb {
		display: block;
		position: static;
		width: 100%;
		height: 140px;
		transform: none !important;
		opacity: 1 !important;
		border-radius: 4px;
		flex: 0 0 100%;
		order: 10;
	}
	.project-row:hover .project-thumb {
		transform: none;
		opacity: 1;
	}
}
</style>
